import cx from 'classnames';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './notfound.module.scss';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column align-items-center">
      <h1 tabIndex={0} className={`${styles.title} text-center`}>
        Oops!
      </h1>
      <h2 className={`text-center ${styles.subtitle}`}>
        404 - The page cannot be found
      </h2>

      <button
        type="button"
        className={cx(styles.back, 'btn btn-link')}
        onClick={() => navigate(-1)}
      >
        Go Back!
      </button>
    </div>
  );
}
